import React from 'react';

interface HilErrorBannerProps {
  message: string;
  onClose?: () => void;
}

export function HilErrorBanner({ message, onClose }: HilErrorBannerProps): React.JSX.Element {
  return (
    <div className="hil-error-banner" role="alert">
      <span className="hil-error-banner__message">{message}</span>
      {onClose && (
        <button className="hil-error-banner__close" onClick={onClose} aria-label="Dismiss error">
          ✕
        </button>
      )}
    </div>
  );
}
